import DesignTokens from '@tableau/design-tokens';
import { ButtonType, ButtonWidget, InlineAlertType, InlineAlertWidget, TabStyles } from '@tableau/widgets';
import React, { useState } from 'react';

import { Messages } from '~src/codegen/Localize';
import { ATTENTION_COLOR } from '~src/settings/styles/CommonStyles';
import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';

export type TestFileServerConnectionButtonProps = Readonly<{
    onTestConnectionClicked: () => Promise<{message: string, messageType: InlineAlertType}>;
    testConnectionDisabled: boolean;
}>;

export type TestFileServerConnectionButtonState = Readonly<{
    message?: string;
    messageType?: InlineAlertType;
    status: 'idle' | 'testing' | 'complete';
    succeeded?: boolean;
}>;

export function TestFileServerConnectionButton(props: TestFileServerConnectionButtonProps) {
  const [state, setState] = useState<TestFileServerConnectionButtonState>({
    status: 'idle',
  });


  return (
    <div className={testconnectionsection}>
          <ButtonWidget
            buttonType={ButtonType.Outline}
            onClick={() => {
              setState({
                ...state,
                status: 'testing',
              });
              props.onTestConnectionClicked().then((result) => {
                setState({
                  ...state,
                  message: result.messageType === InlineAlertType.Error ? Messages.dataConnectSiteSettingsDomainFileServerTestConnectionFailureDetails() : '',
                  messageType: result.messageType,
                  status: 'complete',
                  succeeded: result.messageType !== InlineAlertType.Error,
                });
              });
            }}
            testId="test-connection-fileserver-button"
            showSpinner={state.status === 'testing'}
            disabled={props.testConnectionDisabled}
          >
            {Messages.dataConnectSiteSettingsDomainFileServerTestConnection()}
          </ButtonWidget>
          {renderConnectionTestOutcome(state)}
    </div>
    );
}
function renderConnectionTestOutcome(state: TestFileServerConnectionButtonState) {
  const connectionMessage = state.succeeded ? Messages.dataConnectSiteSettingsDomainFileServerTestConnectionSuccess() : Messages.dataConnectSiteSettingsDomainFileServerTestConnectionFailure();
        const testOutcomeClassname: string = cssClass('test-connectio-fileserver-message', 'test-outcome', {
          color: state.succeeded ? applyColor(DesignTokens.color.font.default.default, TabStyles.Typography.Color.Primary) : applyColor(DesignTokens.color.component.content.alert.default.error.default, ATTENTION_COLOR)
        });
        return state.status === 'complete' ? (
          <InlineAlertWidget
                children={<>
                  <div className={testOutcomeClassname}>
                    <span style={{ display: 'block' }}>{connectionMessage}</span>
                    <span style={{ display: 'block' }}>{state.message}</span>
                  </div>
                </>
                }
                type={state.messageType}
                testId={'test-connection-message'}/>

        ) : null;
}

const testconnectionsection = cssClass('test-connection-fileserver-section', 'root', {
  marginBottom: TabStyles.Spacing.MediumSpace,
});